import { motion } from 'framer-motion';

import superstyled from '@zenbusiness/zui/styles/superstyled';

export const ProductOverlayRoot = superstyled({
  name: 'ProductOverlay',
  slot: 'Root',
  tag: motion.div,
  styles: ({ theme }) => ({
    position: 'fixed',
    inset: 0,
    zIndex: theme.zIndex.appBar,
    backgroundColor: theme.palette.background.grey.main,
    display: 'flex',
    flexDirection: 'column'
  })
});

export const ProductOverlayContent = superstyled({
  name: 'ProductOverlay',
  slot: 'Content',
  tag: 'div',
  styles: () => ({
    width: '100%',
    flex: 1,
    overflow: 'auto',
    padding: '2rem'
  })
});
